import { AxiosInstance } from 'axios';
import { Notification } from '../types/types';

export const notificationApi = (http: AxiosInstance | null) => {
  if (!http) {
    return null;
  }

  return {
    getNotifications: async () => {
      return http.get<Notification[]>('/GetNotifications');
    },
    markNotificationsRead: async (ids: string[]) => {
      return http.post('/MarkNotificationsRead', {
        notificationIds: ids,
      });
    },
    deleteNotification: async (messageId: string) => {
      return http.delete(`/DeleteNotification/${messageId}`);
    },
  };
};
